<div class="min-h-screen bg-cloud-mist font-sans flex flex-col">

  <main>
    <div class="tfr-page-shell-narrow py-10 sm:py-14 lg:py-16">
      <a routerLink="/" class="mb-8 inline-flex text-[13px] font-medium text-slate-blue transition-colors hover:text-midnight-indigo">
        ← Volver al inicio
      </a>

      <!-- Header -->
      <div class="mb-12">
        <span class="inline-flex items-center px-3 py-1 rounded-[50px] text-xs font-semibold tracking-wide
                     bg-pale-gray text-glacier-blue mb-5">Legal</span>
        <h1 class="text-[38px] font-bold leading-[1.21] text-midnight-indigo mb-3">Política de Privacidad</h1>
        <p class="text-[14px] text-steel-gray">Última actualización: {{ updated }}</p>
      </div>

      <!-- Body -->
      <div class="prose-content space-y-10 text-[15px] leading-[1.71] text-slate-blue">

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">1. Responsable del tratamiento</h2>
          <p>
            El responsable del tratamiento de sus datos personales es el titular legal que opera
            <strong class="text-midnight-indigo">TimeFlexRent</strong>,
            con domicilio social en España. Puede contactarnos en
            <a href="mailto:privacidad@timeflexrent.com"
               class="text-action-blue hover:underline">privacidad&#64;timeflexrent.com</a>.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">2. Datos que recopilamos</h2>
          <p>Recopilamos los siguientes datos en función de su rol:</p>
          <ul class="mt-3 space-y-2 list-none pl-0">
            <li class="flex gap-2">
              <span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span><strong class="text-midnight-indigo">Propietarios de espacios:</strong> nombre completo, correo electrónico, número de teléfono, NIF/CIF, datos bancarios para cobros (gestionados por nuestro proveedor de pagos), descripción y fotografías de los espacios.</span>
            </li>
            <li class="flex gap-2">
              <span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span><strong class="text-midnight-indigo">Usuarios / Clientes:</strong> nombre, correo electrónico, historial de reservas y, si aplica, datos de pago tokenizados.</span>
            </li>
            <li class="flex gap-2">
              <span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span>
              <span><strong class="text-midnight-indigo">Datos de uso:</strong> dirección IP, tipo de dispositivo, páginas visitadas y tiempos de sesión, recopilados únicamente si acepta las cookies analíticas.</span>
            </li>
          </ul>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">3. Base jurídica del tratamiento</h2>
          <p>El tratamiento de sus datos se basa en:</p>
          <ul class="mt-3 space-y-2 list-none pl-0">
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-slate-blue shrink-0"></span><span>Ejecución de un contrato (art. 6.1.b RGPD) — para gestionar su cuenta y sus reservas.</span></li>
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-slate-blue shrink-0"></span><span>Interés legítimo (art. 6.1.f RGPD) — para prevenir fraudes y garantizar la seguridad.</span></li>
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-slate-blue shrink-0"></span><span>Consentimiento (art. 6.1.a RGPD) — para el uso de cookies analíticas y comunicaciones de marketing.</span></li>
          </ul>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">4. Residencia de los datos (Firebase / Google Cloud)</h2>
          <p>
            Nuestra plataforma utiliza <strong class="text-midnight-indigo">Google Firebase</strong> con la región configurada en
            <strong class="text-midnight-indigo">europe-west1 (Bélgica)</strong>, dentro del Espacio Económico Europeo (EEE).
            Google LLC actúa como encargado del tratamiento bajo las Cláusulas Contractuales Tipo de la Comisión Europea.
            Más información en la
            <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer"
               class="text-action-blue hover:underline">política de privacidad de Firebase</a>.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">5. Conservación de los datos</h2>
          <p>
            Los datos de cuenta se conservan mientras la cuenta esté activa y durante los 3 años
            posteriores a su eliminación (obligación legal). Los datos de reservas se conservan
            5 años por imperativo fiscal. Los datos analíticos se eliminan a los 14 meses.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">6. Sus derechos (RGPD)</h2>
          <p>Puede ejercer en cualquier momento los derechos de:</p>
          <ul class="mt-3 space-y-2 list-none pl-0">
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span><span><strong class="text-midnight-indigo">Acceso, rectificación y supresión</strong> de sus datos.</span></li>
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span><span><strong class="text-midnight-indigo">Portabilidad</strong> — recibir sus datos en formato estructurado y legible por máquina.</span></li>
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span><span><strong class="text-midnight-indigo">Oposición y limitación</strong> del tratamiento.</span></li>
            <li class="flex gap-2"><span class="mt-1.5 h-1.5 w-1.5 rounded-full bg-action-blue shrink-0"></span><span><strong class="text-midnight-indigo">Retirada del consentimiento</strong> en cualquier momento sin efecto retroactivo.</span></li>
          </ul>
          <p class="mt-4">
            Envíe su solicitud a <a href="mailto:privacidad@timeflexrent.com" class="text-action-blue hover:underline">privacidad&#64;timeflexrent.com</a>.
            Si considera que sus derechos no han sido atendidos, puede reclamar ante la
            <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" class="text-action-blue hover:underline">AEPD</a>.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">7. Cookies</h2>
          <p>
            Utilizamos cookies técnicas (esenciales, sin consentimiento previo) y cookies analíticas
            (Google Analytics 4, con consentimiento explícito). Puede retirar su consentimiento
            en cualquier momento eliminando las preferencias de cookies de este sitio.
          </p>
        </section>

        <section>
          <h2 class="text-[20px] font-semibold text-midnight-indigo mb-3">8. Derecho de desistimiento</h2>
          <p>
            Para ejercer el derecho de desistimiento sobre una reserva, utilice el
            <a routerLink="/desistimiento" class="text-action-blue hover:underline">formulario de desistimiento</a>.
            Trataremos los datos facilitados para tramitar su solicitud conforme a esta política.
          </p>
        </section>

      </div>

      <!-- Back link -->
      <div class="mt-14 pt-8 border-t border-pale-gray">
        <a routerLink="/"
           class="inline-flex items-center gap-2 text-[13px] font-medium text-slate-blue
                  hover:text-midnight-indigo transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
          Volver al inicio
        </a>
      </div>

    </div>
  </main>

  <app-site-footer />

</div>
